
import { computed, defineComponent, ref, Ref } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import utilities from '@/shared/utilities.service';
import profileStore, { B2CProfileEditMode } from '@/b2c/profile/profile.store';
import { Form } from 'vee-validate';
import WebApiMessage from '@/core/http/WebApiMessage.vue';
import ProfileInfoItem from '@/b2c/profile/ui/ProfileInfoItem.vue';

export const changeUserPasswordWebApiMessageKey = 'changeUserPasswordApiMessages';

export default defineComponent({
    name: 'ProfilePassword',
    components: { ProfileInfoItem, WebApiMessage, Form },
    setup() {
        const labels = useBlockLabels();
        const editMode: Ref<boolean> = computed(() => profileStore.isPasswordEditMode);
        const confirmationAnimationTiming: number = 300;
        const resetConfirmationTiming: number = 1500;
        const showConfirmationTiming: number = 3000;
        const showConfirmation: Ref<boolean> = ref(false);

        const submit = async({ password, newPassword, newPasswordConfirm }): Promise<any> => {
            const animationTiming = utilities.delay(resetConfirmationTiming);
            const request = {
                password,
                newPassword,
                passwordConfirmation: newPasswordConfirm,
            };
            const response = profileStore.changePassword(request, changeUserPasswordWebApiMessageKey);
            await Promise.all([
                animationTiming,
                response,
            ]);
            setTimeout(() => {
                doShowConfirmation();
            }, confirmationAnimationTiming + 50);
            return response;
        };

        const doShowConfirmation = (): void => {
            showConfirmation.value = true;
            setTimeout(onChangePasswordDone, showConfirmationTiming);
        };

        const onChangePasswordDone = (): void => {
            profileStore.clearEditMode();
        };

        const setEditMode = (): void => {
            profileStore.setEditMode(B2CProfileEditMode.Password);
        };

        const clearEditMode = (): void => {
            profileStore.clearEditMode();
        };

        const formValidation = {
            password: 'required',
            newPassword: 'required|min-password:8',
            newPasswordConfirm: 'required|same-password:@newPassword',
        };

        return {
            labels,
            formValidation,
            submit,
            editMode,
            setEditMode,
            clearEditMode,
            showConfirmation,
            confirmationAnimationTiming,
            changeUserPasswordWebApiMessageKey,
        };
    },
});
